const DEFAULT_USER = {
  id: '',
  isAuth: false,
  application: {
    title: '',
    firstName: '',
    lastName: '',
    fullMaidenName: '',
    dob: '',
    nationalInsuranceNumber: '',
    isPrivateUKPensison: false,
    currentOccupation: '',
    currentAddress: {
      country: '',
      street: '',
      city: '',
      state: '',
      postalCode: '',
      countryCode: ''
    },
    phone: '',
    email: ''
  }
};

const moduleUser = {
  namespaced: true,
  state: () => ({
    user: DEFAULT_USER
  }),
  getters: {
    userId(state) {
      return state.user.id ?? DEFAULT_USER.id;
    },
    isAuth(state) {
      return state.user.isAuth ?? DEFAULT_USER.isAuth;
    },
    application(state) {
      return state.user.application ?? DEFAULT_USER.application;
    }
  },
  mutations: {
    logIn(state, data) {
      state.user = {
        id: data.id,
        isAuth: true,
        application: formatApplication(data)
      };
    },
    updateApplication(state, data) {
      state.user.application = formatApplication(data);
    },
    logOut(state) {
      state.user = DEFAULT_USER;
    }
  },
  actions: {
    async logInUser({ commit }, payload) {
      commit('logIn', payload);
    },
    async updateUserApplication({ commit }, payload) {
      commit('updateApplication', payload);
    },
    async logOutUser({ commit }) {
      commit('logOut');
    }
  }
};

function formatApplication(application) {
  const result = {
    title: application?.title ?? '',
    firstName: application?.firstName ?? '',
    lastName: application?.lastName ?? '',
    fullMaidenName: application?.fullMaidenName ?? '',
    dob: application?.dob ?? '',
    nationalInsuranceNumber: application?.nationalInsuranceNumber ?? '',
    isPrivateUKPensison: application?.isPrivateUKPensison ?? false,
    currentOccupation: application?.currentOccupation ?? '',
    currentAddress: {
      country: application?.currentAddress?.country ?? '',
      street: application?.currentAddress?.street ?? '',
      city: application?.currentAddress?.city ?? '',
      state: application?.currentAddress?.state ?? '',
      postalCode: application?.currentAddress?.postalCode ?? '',
      countryCode: application?.currentAddress?.countryCode ?? ''
    },
    phone: application?.phone ?? '',
    email: application?.email ?? ''
  };

  return result;
}

export default moduleUser;
